import axios from 'axios';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import configData from '../config.json';

const LandingPage = () => {
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    const empId = (params.get("ei") !== null) ? params.get("ei") : "";
    sessionStorage.clear();
    useEffect(() => {
        if(empId != ""){
            SetToken(empId);
        }else{
            window.location.replace('https://btsg.net/intranet/login.php?self=meeting-unicorn');
        }
    }, []);

    const SetToken = (employeeId) => {
        let url = configData.API_URL_AUTHEN + "login-b2b";
        let data = {
            user_name: configData.APP_USERNAME,
            password: configData.APP_PASS,
            app_key: configData.APP_KEY,
            app_secret: configData.APP_SECRET
        };
        axios.post(url, data, { responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                SetUser(employeeId, respData.data.token);
            }else{
                console.log(respData);
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    const SetUser = (emplyeeId, strToken) => {
        let url = configData.API_URL + "user/emp-id/" + emplyeeId;
        let token = "Bearer " + strToken;
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                sessionStorage.setItem("tokenmeetingunicorn", strToken);
                sessionStorage.setItem("uid", respData.data[0].id_employee_general);
                sessionStorage.setItem("ueid", respData.data[0].employee_id);
                history.push("/");
            }else{
                window.location.replace('https://btsg.net/intranet/index.php');
            }
        })
        .catch(error => {
            console.log(error);
        });
    };

    return (
        <React.Fragment>
            <div> </div>
        </React.Fragment>
    )
};

export default LandingPage;